import createImmutableSelector from 'lib/immutable/selector'
import { IStaticContent } from '../models'

// TODO: import Store type and add reducer type in Store interface
const getStaticContent = (state: any): IStaticContent => state.get('staticContentReducer')

export const staticContentSelector = createImmutableSelector(getStaticContent, (staticContent) => staticContent)
export const footerSelector = createImmutableSelector(getStaticContent, (staticContent) => staticContent.get('footer'))
export const headerSelector = createImmutableSelector(getStaticContent, (staticContent) => staticContent.get('header'))
